<!--
bellow is the table  -->

<div class="container-fluid pagecard employee-main" id="employee-list-page">
    <learn-more [title]="'Support Tickets' | translate | async"
        link="https://support.eatos.com/en-us/article/dashboard-employee-employees-2abmd3/"
        [content]="'Addressing issues and enhancing performance.' | translate | async"></learn-more>
    <!-- <app-support-summary [ngClass]="{ 'no-pointer':!canAccess }" [closeTickets]="totalClose"
        [totalTickets]="totalCount"></app-support-summary> -->
    <div class="" style="width:auto">
        <div class="row">
            <!-- Total Tickets -->
            <div class="col-12 col-md-4">
                <div class="mini-card">
                    <div class="row g-0">
                        <div class="col-8">
                            <div class="f-14 mb-1 fw-600">
                                Total Tickets
                                <i style="padding:2px" class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]=" 'Shows total number of Tickets raised to Support Team' | translate | async"
                                    triggers="mouseenter:mouseleave"
                                    [popoverTitle]="'Total Tickets' | translate | async" placement="right"></i>
                            </div>
                            <h6 class="fw-600 f-18">{{this.totalCount}}</h6>
                        </div>
                        <div class="col-4 text-end align-self-center">
                            <img src="assets/images/sale-icon.svg">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Open Tickets -->
            <div class="col-12 col-md-4">
                <div class="mini-card">
                    <div class="row g-0">
                        <div class="col-8">
                            <div class="f-14 mb-1 fw-600">
                                Open Tickets
                                <i style="padding:2px" class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]=" 'A number of Tickets needing a response from Support Team' | translate | async"
                                    triggers="mouseenter:mouseleave" [popoverTitle]="'Open Tickets' | translate | async"
                                    placement="right"></i>
                            </div>
                            <h6 class="fw-600 f-18">{{this.totalOpen}}</h6>
                        </div>
                        <div class="col-4 text-end align-self-center">
                            <img src="assets/images/transactions-icon.svg">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Closed Tickets -->
            <div class="col-12 col-md-4">
                <div class="mini-card">
                    <div class="row g-0">
                        <div class="col-8">
                            <div class="f-14 mb-1 fw-600">
                                Closed Tickets
                                <i style="padding:2px" class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]=" 'Total number of Tickets And queries solved.' | translate | async"
                                    triggers="mouseenter:mouseleave"
                                    [popoverTitle]="'Closed Tickets' | translate | async" placement="right"></i>
                            </div>
                            <h6 class="fw-600 f-18">{{this.totalClose}}</h6>
                        </div>
                        <div class="col-4 text-end align-self-center">
                            <img src="assets/images/sale-icon.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="gross-tabs-sec border-bottom position-relative" style="z-index: 900">
        <!-- <div class="mb-3 flex-wrap">
            <div
              class="datepickerwrap form-control"
              daterangepicker
              [options]="options"
              (selected)="selectedDate($event)"
              style="max-width: 290px !important; position: relative"
              (click)="setDateTexts()"
            >
              <span
                ><span class="display-date">{{ startDateDisplayFormatted | translate | async }}</span> -
                <span class="display-date">{{ endDateDisplayFormatted | translate | async }}</span>
                </span
              >
              <img
                src="../../../../assets/fonts/bx-calendar.svg"
                class="ms-2 me-0"
                style="position: absolute; right: 0"
              />
            </div>
          </div> -->
        <!-- <nav ngbNav #nav="ngbNav" class="nav-tabs gross_tabs" [(activeId)]="active"> -->
        <!-- <ng-container [ngbNavItem]="1"> -->
        <!-- <a ngbNavLink> {{ 'Active' | translate | async }}</a> -->
        <!-- <ng-template ngbNavContent> -->
        <!-- empty list UI -->
        <div class="empty-courses" *ngIf="isEmpty">
            <div class="text-center">
                <img src="assets\images\Employees.svg" class="mb-2" />
                <h2 class="fw-600 mb-4">{{ 'Support Tickets' | translate | async }}</h2>
                <p class="f-16 mb-5"> {{ 'No Support Tickets Data Present' | translate | async }}</p>
                <!-- <button accessControl module="Employee" access="3" class="create-btn" (click)="goToAddPage()">
                  {{ 'Create Employee(s)' | translate | async }}
                </button> -->
            </div>
        </div>

        <!--  table UI -->
        <div *ngIf="!isEmpty" [ngClass]="isEmpty ? 'isEmpty' : ''" class="position-relative" style="margin-top: -15px">
            <div class="table-responsive employees-table2 archive-data">
                <table id="employees-table" class="display table-make-responsive" cellspacing="0" width="100%" datatable
                    [dtOptions]="dtOptions">

                    <thead class="make-table-resp" style="border-top: 1px solid #6666;">
                        <tr>
                            <th class="text-center"> Ticket ID </th>
                            <th class="text-center"> Subject</th>
                            <th class="text-center"> Merchant Name</th>
                            <th class="text-center"> Store Name </th>
                            <th class="text-center"> Email </th>
                            <th class="text-center"> Mobile Number </th>
                            <th class="text-center"> Created At </th>
                            <th class="text-center"> Status </th>
                        </tr>
                    </thead>
                    <tbody class="fw-500">
                        <!-- <ng-container>

                    </ng-container> -->
                        <!-- (click)="openModal(content, employee)" -->
                        <tr *ngFor="let employee of employees; let i = index" class="table-row">
                            <!--  -->
                            <td> {{ employee.issueName ? employee.issueName : 'No Ticket ID Available' | translate |
                                async}}</td>
                               <td [title]="employee?.issueTitle"> {{
                                    (employee.issueTitle.length > 20
                                    ? (employee.issueTitle | slice : 0 : 17) + "..."
                                    : (employee.issueTitle | titlecase)) | translate | async
                                    }}</td>
                            <!-- <td>{{ employee.issueTitle ? employee.issueTitle : 'No Subject Available' | translate |
                                async}}</td> -->
                            <td>{{ employee.merchantName ? employee.merchantName : 'No MerchantName Available' |
                                translate |
                                async}}</td>
                            <td>{{ employee.storeName ? employee.storeName : 'No StoreName Available' | translate |
                                async}}</td>
                            <td style="
                          font-size: 14px;
                          color: #000000;
                          width: fit-content !important;
                          overflow: hidden !important;
                          white-space: nowrap !important;
                          text-overflow: ellipsis !important;
                        ">
                                {{ employee.contactInfo.email ? employee.contactInfo.email : 'No Email Available' }}
                            </td>
                            <td style="
                      width: fit-content !important;
                      overflow: hidden !important;
                      white-space: nowrap !important;
                      text-overflow: ellipsis !important;
                    ">
                                {{ employee.contactInfo.phoneNumber ? employee.contactInfo.phoneNumber : 'No Mobile
                                Available' | translate | async}}
                            </td>

                            <td class="text-center">
                                <div>
                                    {{ _convertDate(employee.employeeId, employee.createdAt) | translate | async }}
                                </div>
                            </td>
                            <td class="text-center create-date">
                                <div class="hidden-menu">
                                    <ng-container *ngIf="employee?.issueStatus === 1; else openStatus">
                                        {{ 'Close' | translate | async }}
                                    </ng-container>
                                    <ng-template #openStatus>
                                        {{ 'Open' | translate | async }}
                                    </ng-template>
                                </div>
                                <div class="hover-menu">
                                    <button class="tooltip-custom" accessControl module="Support Tickets" access="3"
                                        (click)="updateTicket(employee._id)">
                                        <img src="/assets/images/Edit.svg" alt="edit" />
                                        <div class="cust-tool">{{ "Edit" | translate | async }}</div>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- MODAL -->
<ng-template #content let-offcanvas>
    <div style="overflow: auto;">
        <div>
            <!-- Show Loader -->
            <div *ngIf="loaderState" class="editproduct-main"
                style="position: relative; height: 962px; display: flex; justify-content: center; align-items: center;">
                <div class="loader-content-overlay">
                    <img alt="img" src="../../../../../assets//images/loaders/eatos_loading_0-Black.gif" width="190"
                        height="190" />
                </div>
            </div>
        </div>
        <!-- Show History -->
        <div *ngIf="!loaderState" class="offcanvas-body">
            <div class="d-flex justify-content-between mb-4 gap-4">
                <div class="f-30 fw-700 text-black paid_text text-uppercase">
                    {{ employeeDetails?.employeeCompleteName?.toUpperCase() }}
                </div>
                <div style="display: flex; justify-content: end;" class="align-self-center">
                    <button type="button" class="btn-close f-14 p-0 btn-details" aria-label="Close" (click)="
                closeModal(content); offcanvasService.dismiss('Cross click')
              "></button>
                </div>
            </div>

            <div class="bill-details h-100 d-flex flex-column h-100">
                <ng-container>
                    <div>
                        <!-- Employee Details -->
                        <div class="f-16 fw-500 receipt-num">
                            <div class="d-flex justify-content-between mb-2">
                                <div *ngIf="employeeDetails?.contactInfo?.email">
                                    {{ "Email" }} :<b> {{ employeeDetails?.contactInfo?.email }}</b>
                                </div>
                                <div *ngIf="!employeeDetails?.contactInfo?.email">
                                    {{ "Email" }} :<b> No Email Available </b>
                                </div>
                                <div *ngIf="employeeDetails.createdAt == 0">---------</div>
                                <div *ngIf="employeeDetails.createdAt != 0" class="text-uppercase">
                                    {{
                                    _convertDate(employeeDetails.employeeId, employeeDetails.createdAt) | translate |
                                    async
                                    }}
                                </div>
                            </div>
                            <div class="d-flex justify-content-between mb-2">
                                <div *ngIf="employeeDetails?.contactInfo?.phoneNumber">
                                    {{ " Mobile" }} :<b> {{ employeeDetails?.contactInfo?.phoneNumber }}</b>
                                </div>
                                <div *ngIf="!employeeDetails?.contactInfo?.phoneNumber">
                                    {{ " Mobile" }} :<b> No Mobile Available </b>
                                </div>
                                <div *ngIf="employeeDetails.createdAt == 0">---------</div>
                                <div *ngIf="employeeDetails.createdAt != 0" class="text-uppercase">
                                    {{
                                    _convertTime(employeeDetails.employeeId, employeeDetails.createdAt) | translate |
                                    async
                                    }}
                                </div>
                            </div>
                            <!-- <div *ngIf="employeeDetails?.supportPin" class="mb-2">
                  {{ "Support pin :" | translate | async }}
                  <b>{{ employeeDetails?.supportPin }}</b> -->
                            <!-- <i
                      class="fas fa-sync-alt m-1 cs-pointer"
                      (click)="generateSupportPin()"
                    ></i> -->
                            <!-- </div> -->
                            <!-- <div *ngIf="!employeeDetails?.supportPin" class="mb-2">
                  {{ "Support pin :" | translate | async }}
                  <b> No Support Pin Available </b>
                </div>
              </div> -->
                            <!-- Order History Table -->
                            <!-- <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3" style="justify-content: space-between;">
                    <div class="f-14 fw-600 me-3">{{ 'Employee Order History' | translate | async }}</div>
                    <button class="btn btn-primary" (click)="fetchEmployeeOrderHistory()" style="background-color: black; color: white; padding: revert;">
                      <i
                      class="fas fa-sync-alt m-1 cs-pointer"
                    ></i>
                      {{ 'Fetch Orders' | translate | async }}
                    </button>
                  </div>
                  <div class="overflow-auto">
                    <table class="w-100 normal_table" style="line-height: 35px !important;">
                      <tr class="thead_bg">
                        <th class="fw-600 f-14">{{'Date Created' | translate | async}}</th>
                        <th class="fw-600 f-14">{{'Order Number' | translate | async}}</th>
                        <th class="fw-600 f-14">{{'Order Type' | translate | async}}</th>
                        <th class="fw-600 f-14 text-start">{{'Amount' | translate | async}}</th>
                      </tr>
                      <tbody>
                        <tr *ngIf="!employeeOrderHistory.length">
                          <td colspan="5" class="fw-600 f-14 text-center">
                            {{'No available orders' | translate | async}}
                          </td>
                        </tr>
                        <ng-container *ngFor="let order of employeeOrderHistory; let x = index">
                          <tr *ngIf="employeeOrderHistory.length"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#viewOrderModal"
                            aria-controls="viewOrderModal"
                          >
                            <td class="text-start">
                              {{ _convertDate(order.orderId, order.createdAt) }}<br />

                            </td>
                            <td style="display: flex; justify-content: center;">#{{ order.orderNumber | translate | async }}</td>
                            <td>
                              {{ orderTypeText(order.orderType) | translate | async }}
                            </td>
                            <td class="text-start">
                              {{ order.actualPaidAmount | currency : currency : "symbol" | translate | async}}
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> -->
                        </div>
                    </div>
                </ng-container>

                <!-- Issue Details -->
                <ng-container>
                    <div>
                        <div class="w-100 sales-main">
                            <div class="improve-all">
                                <ckeditor [editor]="Editor" (ready)="onReady($event)" tagName="textarea"
                                    [(ngModel)]="editorContent" id="classic-editor" name="classic-editor"
                                    (change)="onChange($event)" (focus)="onFocus($event)" (blur)="onBlur($event)"
                                    [config]="editorConfig"></ckeditor>
                                <div style="display: flex; justify-content: space-between; margin-top: 20px;">
                                    <!-- <button
                  (click)="createIssue()"
                  class="submit-btn f-16 fw-600 pointer"
                >
                  {{ "Update Issue" | translate | async }}
                </button> -->
                                    <button (click)="createIssue('close')" class="submit-btn f-16 fw-600 pointer">
                                        {{ "Close Issue" | translate | async }}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

    </div>

</ng-template>

<!-- Reset Modal -->
<ng-template #reset2faContent role="document" let-modal>
    <div class="modal-body border-0">
        <div class="delete-icon-info">
            <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex; animation: none !important">
                <div class="swal2-icon-content">!</div>
            </div>
            <h2 class="swal2-title" id="swal2-title" style="display: flex; text-align: center;">
                {{ 'Are you sure you want to reset the 2FA settings?' | translate | async }}
            </h2>
        </div>
    </div>
    <div class="modal-footer border-0">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 text-center">
                    <button class="btn add-btn-one fw-bold mt-2" (click)="resetEmployee(reset2faId, reset2faContent)">
                        {{'Yes, reset it!' | translate | async }}
                    </button>
                    <button class="btn btn-dark add-btn-two fw-bold mt-2" style="margin-left: 15px"
                        (click)="cancelDelete(reset2faContent)">
                        {{'Cancel' | translate | async }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
